module.exports = __webpack_public_path__ + "static/image/font/pc/bmdohyeon-3@3x.jpg?a943ea99";